import config from "../config/config.json";
import { headers } from "./../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuth,
  headersWithAuthWithoutBody,
} from "../APIHelpers/Responses";

export const usersManagementServices = {
  //User
  userRegistration,
  updateUserData,
  getUserData,
  softDeleteRestoreUser,
  getSingleUser,
  getCurrentUserDetails,

  //Address
  getCountries,
  getStates,
  getCities,
};

// User Registration
async function userRegistration(userData) {
  const response = await fetch(
    `${config.API_URL}userRegistration`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  // handleResponse(data)
  return data;
}

// Update User
async function updateUserData(userData) {
  const response = await fetch(
    `${config.API_URL}updateUserData`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  return data
}

// Soft Delete & Restore User
async function softDeleteRestoreUser(userData) {
  const response = await fetch(
    `${config.API_URL}softDeleteRestoreUser`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  // handleResponse(data)
  return data
}

// Get User List
async function getUserData(status, roleType, searchData, page, length) {
  let response
  if (page && length) {
    response = await fetch(
      `${config.API_URL}getUserData/${status}/${roleType}?search=${searchData || ""}&page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL}getUserData/${status}/${roleType}?search=${searchData || ""}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}

//Get Single User
async function getSingleUser(userId) {
  const response = await fetch(
    `${config.API_URL}getSingleUser/${userId}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

//Get Current User
async function getCurrentUserDetails() {
  const response = await fetch(
    `${config.API_URL}getCurrentUser`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

//Get Countries
async function getCountries() {
  const response = await fetch(
    `${config.API_URL}getCountries`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

//Get States
async function getStates(countryName) {
  const response = await fetch(
    `${config.API_URL}getStates/${countryName}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

//Get Cities
async function getCities(stateName) {
  const response = await fetch(
    `${config.API_URL}getCities/${stateName}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}